export enum Severity {
  RECOVERABLE = 10,
  WARNING = 20,
  ERROR = 30,
  FATAL = 40,
}

export interface IErrorDefinition {
  name: string;
  id: number;
  severity?: Severity;
}

export interface ILogParams {
  reason?: Error;
  p1?: string;
  p2?: string;
  p3?: string;
  p4?: string;
}

export interface IErrorDefinitions {
  [key: string]: IErrorDefinition | IErrorDefinitions;
}

export type IErrorParams = { errorDefinition: IErrorDefinition } & ILogParams;
export type IErrorReceiver = (params: IErrorParams) => void;
